<ng-container>
    <app-sharing-options (platformLinkCopied)="onPlatformLinkCopied($event)"
                         [sharingContext]="{page: pageService.getCurrentPages()[0]}"></app-sharing-options>
</ng-container>


@if (!isMobileVersion && pagesShown !== 1) {
    <li>
        @if (!isMobileVersion && pagesShown !== 1) {
            <a (click)="onDownloadLinkClicked($event, doublePageDownloadLink)"
               class="li" target="_blank">
                <i aria-hidden="true" class="fa fa-download"></i>
                <span>Doppelseite als PDF speichern</span>
            </a>
        }
    </li>
}


@if (isMobileVersion || pagesShown === 1) {
    <li>
        <a (click)="onDownloadLinkClicked($event, currentDownloadLink)" [attr.href]="currentDownloadLink">
            <img [src]="'icon-buchseite-download.png' | asset" alt="Downloadicon">
            <span>Seite {{ applicationStateService.currentIndex | realPageNumber }} als PDF speichern</span>
        </a>
    </li>
}

@if (!isMobileVersion) {
    @if (pagesShown > 1) {
        <li>
            <a (click)="onDownloadLinkClicked($event, leftPageDownloadLink)" target="_blank">
                <img [src]="'icon-linke-buchseite.png' | asset " alt="Icon der linken Seite">
                <span>Linke Seite als PDF speichern</span>
            </a>
        </li>
        <li>
            <a (click)="onDownloadLinkClicked($event, rightPageDownloadLink)" target="_blank">
                <img [src]="'icon-rechte-buchseite.png' | asset " alt="Icon der rechten Seite">
                <span>Rechte Seite als PDF speichern</span>
            </a>
        </li>
    }
}
